import {
    Box,

} from '@mui/material'

function BonusCouponEx() {

    return(
        <Box
        sx={{
            background: '#f1f2f2',
            margin: '20px',
            padding: '20px',
            borderRadius: '5px'
        }}>
        <Box
            sx={{
                fontWeight: 'bold'
            }}>
            보너스쿠폰이란?
        </Box>
        <br></br>
        <Box
            sx={{
                fontSize: '14px'
            }}>
            클래스쿠폰과 마찬가지로 보너스쿠폰도 예약할 때 사용할 수 있습니다.
            <br></br>
            기한이 남아있는 클래스쿠폰 중 사용하지 않은 쿠폰을 보너스쿠폰으로 바꿀 수 있습니다.
            <br></br>
            <br></br>
            쿠폰 구매시 남아있는 쿠폰이 있는 경우, 보너스쿠폰 항목이 활성화됩니다.
            해당 항목을 선택하고 결제를 진행하면 남아있는 쿠폰은 전부 보너스쿠폰으로 바뀌게 됩니다.
            <br></br>
            바뀐 보너스쿠폰은 구매한 쿠폰과 동일한 유효기간을 가지게 됩니다.
            <br></br>
            <br></br>
            예) 남은기간 4일인 클래스쿠폰 15장을 클래스쿠폰 4회권(유효기간 30일) 구매시 보너스쿠폰으로 바꿨을 때,
            유효기간 30일인 보너스쿠폰 15장 + 유효기간 30일인 클래스쿠폰 4회권을 보유하게 됨.
        </Box>
    </Box>
    )
}

export default BonusCouponEx;